const Theme = {
  body_background_color: '#6AC17C',
  logo_image_url: 'culturelanaudiere.png',
  header_full_height: true,

  token_url: 'culturelanaudiere.png',
  token_border_radius: 50,
  number_hidden: true,

  title_font: `'Nunito', sans-serif`,
  title_size: 31,
  title_lineheight: 38.8,
  title_color: '#222222',

  subtitle_size: 24,
  subtitle_lineheight: 31.8,

  text_font: `'Varela Round', sans-serif`,
  text_size: 15,
  text_lineheight: 24,
  text_color: 'black',

  legend_color: '#828282',

  button_color: '#6AC17C',
  button_radius: 50,
  button_text_lineheight: 24,
  button_text_size: 15,
  button_text_weight: 600,
  button_text_letter_spacing: 0.5,

  separator_color: '#90C09A',

  footer_text_color: '#222222',
}

export default Theme
